<template>
  <div class="page-index trace-index">
    <div v-if="list.length === 0">数据加载中...</div>
    <el-carousel trigger="click" height="150px">
      <el-carousel-item v-for="item in adv" :key="item">
        <el-link :underline="false" :href="'http://' + item.topUrl">
          <el-image style="width: 100vw;height: 150px" :src="item.topCoverPath" fit="fill"></el-image>
        </el-link>
      </el-carousel-item>
    </el-carousel>
    <el-form class="form">
      <el-form-item class="param-box" v-for="item in list" :key="item.id" :label="item.name">
        <div class="text-right">{{item.value}}</div>
      </el-form-item>
    </el-form>
    <el-carousel trigger="click" height="150px">
      <el-carousel-item v-for="item in adv" :key="item">
        <el-link :underline="false" :href="'http://' + item.bottomUrl">
          <el-image style="width: 100vw;height: 150px" :src="item.bottomCoverPath" fit="fill"></el-image>
        </el-link>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script type="text/ecmascript-6">
  import { apiDetail } from '../../api/trace'

  export default {
    name: 'system',
    data() {
      return {
        code: '',
        list: [],
        adv: []
      }
    },
    created() {
      this.code = this.$route.query.code
      this.getData()
    },
    activated() {},
    methods: {
      getData() {
        if (this.code) {
          apiDetail(this.code).then(data => {
            this.list = data.data.info
            this.adv = data.data.urls
          })
        }
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.trace-index
    width 100%
    .form
      height calc(100vh - 300px)
      overflow hidden
      overflow-y auto
      .param-box
        padding 10px 30px
        margin 0
        border-bottom 1px solid #EFEFEF
        .el-form-item__label
          font-size 18px
        .text-right
          text-align right
          font-size  16px
</style>
